import React, { useMemo } from 'react';
import * as glb from '../../globals';
import { getSelectableUsersWithIncluded } from '../../utils/userLookup';
import { isReportFullAccessUser } from '../../utils/reportAccess';
import GonderilmisSablonlar from '../RAPOR_WHATSAPP_TOPLU/GonderilmisSablonlar';

export default function AiWhatsAppKuyruk() {
  const users = useMemo(() => getSelectableUsersWithIncluded(glb.default.KULLANICILkp), []);
  return <GonderilmisSablonlar mode="ai" users={users} canEdit={isReportFullAccessUser()} />;
}
